import { OPTIMIZELY_FEATURE } from '@/optimizely/constants'
import type { OptimizelyHookResult } from '@/optimizely/types'
import { useOptimizelyFeature } from '@/optimizely/utils'

export const useNbaPlayoffsDesktopHeroFeature = (): OptimizelyHookResult => {
    return useOptimizelyFeature(OPTIMIZELY_FEATURE.nbaPlayoffsDesktopHero)
}
